import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelPipe } from './label.pipe';

@NgModule({
  declarations: [LabelPipe],
  imports: [CommonModule],
  exports: [LabelPipe],
})
export class LabelPipeModule {}
